let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bKixw")).then(() => parcelRequire('6g2r3'));